import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const heightsApi = api
  .enhanceEndpoints({
    addTagTypes: ["heights", "height"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      heights: builder.query({
        query: ({ personalInformationId, status }) => ({
          url: `heights`,
          method: RequestMethod.GET,
          params: camelToSnake({
            personalInformationId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["heights"],
      }),
      height: builder.query({
        query: ({ personalInformationId, status, id }) => ({
          url: `heights/${id ?? "0"}`,
          method: RequestMethod.GET,
          params: camelToSnake({
            personalInformationId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["height"],
      }),
    }),
  });

export const { useHeightQuery, useHeightsQuery } = heightsApi;
